/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.graphics = { 

  // A pie chart for credits display. 
  // Pretty tightly coupled to the colors on settings layout.
  // Modified from http://jsfiddle.net/da5LN/62/
  credits_donut(percentage, size) {
    const light_color = "#539b23";
    const dark_color  = "#2a5c0c";
    const svgns = "http://www.w3.org/2000/svg";
    const chart = document.createElementNS(svgns, "svg:svg");
    chart.setAttribute("width", size);
    chart.setAttribute("height", size);
    chart.setAttribute("viewBox", "0 0 " + size + " " + size);

    // Background circle
    const back = document.createElementNS(svgns, "circle");
    back.setAttributeNS(null, "cx", size / 2);
    back.setAttributeNS(null, "cy", size / 2);
    back.setAttributeNS(null, "r",  size / 2);
    back.setAttributeNS(null, "fill", light_color);
    chart.appendChild(back);

    // primary wedge
    const path = document.createElementNS(svgns, "path");
    const unit = (Math.PI *2) / 100;    
    const startangle = 0;
    const endangle = (percentage * unit) - 0.001;
    const x1 = (size / 2) + ((size / 2) * Math.sin(startangle));
    const y1 = (size / 2) - ((size / 2) * Math.cos(startangle));
    const x2 = (size / 2) + ((size / 2) * Math.sin(endangle));
    const y2 = (size / 2) - ((size / 2) * Math.cos(endangle));

    let big = 0;
    if ((endangle - startangle) > Math.PI) { big = 1; }

    const d = "M " + (size / 2) + "," + (size / 2) +    // Start at circle center
        " L " + x1 + "," + y1 +                   // Draw line to (x1,y1)
        " A " + (size / 2) + "," + (size / 2) +   // Draw an arc of radius r
        " 0 " + big + " 1 " +                     // Arc details...
        x2 + "," + y2 +                           // Arc goes to to (x2,y2)
        " Z";                                      // Close path back to (cx,cy)
    path.setAttribute("d", d); // Set this path 
    path.setAttribute("fill", dark_color);
    chart.appendChild(path); // Add wedge to chart

    // foreground circle
    const front = document.createElementNS(svgns, "circle");
    front.setAttributeNS(null, "cx", (size / 2));
    front.setAttributeNS(null, "cy", (size / 2));
    front.setAttributeNS(null, "r",  (size * 0.34)); // the bigger the number, the "fatter" the donut
    front.setAttributeNS(null, "fill", "#f2f0f1");
    chart.appendChild(front);

    // Text label
    const text = document.createElementNS(svgns, "text");
    text.setAttribute("x", size / 2);
    text.setAttribute("y", size / 1.8);
    text.setAttribute("fill", "#333");
    text.setAttribute("text-anchor", "middle");
    text.appendChild(document.createTextNode(percentage+"%"));
    chart.appendChild(text);

    return chart;
  }
};

